/* ==========================================================================
   VOCAL CHEF — shared behaviour.
   Head-loaded, document-level delegation only, so every control keeps working
   through Section Rendering re-renders and theme-editor section reloads.
   ========================================================================== */
(function () {
  'use strict';

  var R = window.VCROUTES || {};
  var S = window.VCSHOP || { moneyFormat: '£{{amount}}', strings: {} };
  var doc = document;
  var html = doc.documentElement;

  var $  = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };

  /* ---------------- money ---------------- */
  function fmt(cents, format) {
    var f = format || S.moneyFormat || '£{{amount}}';
    var value = '';
    var pat = /\{\{\s*(\w+)\s*\}\}/;
    function num(n, precision, thousands, decimal) {
      if (isNaN(n) || n == null) n = 0;
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.');
      var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return head + (parts[1] ? decimal + parts[1] : '');
    }
    switch ((f.match(pat) || [])[1]) {
      case 'amount':                  value = num(cents, 2); break;
      case 'amount_no_decimals':      value = num(cents, 0); break;
      case 'amount_with_comma_separator':      value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_with_space_separator':      value = num(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' ', ' '); break;
      case 'amount_with_period_and_space_separator':  value = num(cents, 2, ' ', '.'); break;
      default: value = num(cents, 2);
    }
    return f.replace(pat, value);
  }

  /* ---------------- header state ----------------
     The header is solid at every scroll position; the only thing that moves is
     the announcement strip, which rolls away once scrolling starts. */
  var ticking = false;
  /* with the announcement bar removed there is no 34px strip to clear */
  if (!doc.querySelector('.abar')) html.style.setProperty('--vc-abH', '0px');
  function headerState() {
    html.classList.toggle('vc-sc', window.scrollY > 24);
    ticking = false;
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(headerState); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  /* first read of scrollY waits for a frame, so boot never forces a layout */
  requestAnimationFrame(headerState);

  /* ---------------- overlays: scroll-lock + focus trap ---------------- */
  var openLayers = [];
  var lastFocus = null;
  var scrollY = 0;

  function lock() {
    if (openLayers.length !== 1) return;
    scrollY = window.scrollY;
    html.style.overflow = 'hidden';
    if (/iP(hone|ad|od)/.test(navigator.userAgent)) {
      doc.body.style.position = 'fixed';
      doc.body.style.top = -scrollY + 'px';
      doc.body.style.width = '100%';
    }
  }
  function unlock() {
    if (openLayers.length) return;
    html.style.overflow = '';
    if (doc.body.style.position === 'fixed') {
      doc.body.style.position = '';
      doc.body.style.top = '';
      doc.body.style.width = '';
      window.scrollTo({ top: scrollY, behavior: 'instant' });
    }
  }
  function focusables(root) {
    return $$('a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])', root)
      .filter(function (el) { return el.offsetParent !== null || el.getClientRects().length; });
  }
  function openLayer(el) {
    if (!el || el.classList.contains('on')) return;
    lastFocus = doc.activeElement;
    el.classList.add('on');
    el.setAttribute('aria-hidden', 'false');
    openLayers.push(el);
    lock();
    var f = focusables(el)[0];
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeLayer(el) {
    if (!el || !el.classList.contains('on')) return;
    el.classList.remove('on');
    el.setAttribute('aria-hidden', 'true');
    openLayers = openLayers.filter(function (x) { return x !== el; });
    unlock();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function closeTop() {
    if (openLayers.length) closeLayer(openLayers[openLayers.length - 1]);
  }

  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeTop(); return; }
    if (e.key !== 'Tab' || !openLayers.length) return;
    var layer = openLayers[openLayers.length - 1];
    var f = focusables(layer);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------------- delegated triggers ---------------- */
  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-mnav]'))        { e.preventDefault(); openLayer($('.mnav')); return; }
    if (t.closest('[data-mnav-close]'))  { e.preventDefault(); closeLayer($('.mnav')); return; }
    if (t.closest('.mnav-p a[href]'))    { closeLayer($('.mnav')); return; }
    if (t.closest('[data-cart-open]'))   { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-cart-close]'))  { e.preventDefault(); closeLayer($('#vcCart')); return; }
  });

  function openCart() { openLayer($('#vcCart')); }
  function closeCart() { closeLayer($('#vcCart')); }

  /* ---------------- toast ---------------- */
  var toastTimer;
  function toast(msg, kind) {
    var t = $('.toast');
    if (!t) { t = doc.createElement('div'); t.className = 'vc toast vc-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); doc.body.appendChild(t); }
    t.innerHTML = '<i class="fa-solid ' + (kind === 'error' ? 'fa-circle-exclamation' : 'fa-check') + '"></i>' + msg;
    t.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('on'); }, 2600);
  }

  /* ---------------- cart ---------------- */
  var CART_SECTION = 'vc-cart-drawer';
  var busy = false;

  function sectionsUrl() { return window.location.pathname; }

  function paintCount(n) {
    $$('.cbadge').forEach(function (b) {
      b.textContent = n;
      b.classList.toggle('on', n > 0);
    });
    $$('[data-cart-count-text]').forEach(function (b) {
      b.textContent = n + ' ' + (n === 1 ? (S.strings.item || 'item') : (S.strings.items || 'items'));
    });
  }

  function swapDrawer(sections) {
    var markup = sections && sections[CART_SECTION];
    if (!markup) return;
    var host = doc.getElementById('shopify-section-' + CART_SECTION);
    if (!host) return;
    var scroller = $('.cart-body', host);
    var keepTop = scroller ? scroller.scrollTop : 0;
    var focusKey = doc.activeElement && doc.activeElement.getAttribute ? doc.activeElement.getAttribute('data-focus-key') : null;
    var tmp = doc.createElement('div');
    tmp.innerHTML = markup;
    var fresh = tmp.querySelector('#shopify-section-' + CART_SECTION);
    host.innerHTML = fresh ? fresh.innerHTML : markup;
    var s2 = $('.cart-body', host);
    if (s2) s2.scrollTop = keepTop;
    if (focusKey) {
      var back = host.querySelector('[data-focus-key="' + focusKey + '"]');
      if (back) back.focus();
    }
    animateShip(host);
  }

  function animateShip(root) {
    var fill = $('#shipFill', root || doc);
    if (!fill) return;
    var pct = fill.getAttribute('data-pct') || '0';
    fill.style.width = '0%';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { fill.style.width = pct + '%'; });
    });
  }

  /* the cart PAGE lives in a JSON template, so its section id is generated
     (template--123__vc-cart-main). Read it off the DOM rather than guessing. */
  function cartPageId() {
    var el = $('[data-vc-cart-main]');
    var host = el && el.closest('.shopify-section');
    return host ? host.id.replace('shopify-section-', '') : null;
  }

  function refreshCartPage(sections) {
    var id = cartPageId();
    if (!id || !sections || !sections[id]) return;
    var host = doc.getElementById('shopify-section-' + id);
    if (!host) return;
    var tmp = doc.createElement('div');
    tmp.innerHTML = sections[id];
    var fresh = tmp.querySelector('#shopify-section-' + CSS.escape(id));
    host.innerHTML = fresh ? fresh.innerHTML : sections[id];
  }

  function wanted() {
    var id = cartPageId();
    return id ? CART_SECTION + ',' + id : CART_SECTION;
  }

  function cartFetch(url, body) {
    body.sections = wanted();
    body.sections_url = sectionsUrl();
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, data: j }; }); });
  }

  function afterMutation(res) {
    swapDrawer(res.data.sections);
    refreshCartPage(res.data.sections);
    return fetch(R.cart ? R.cart + '.js' : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paintCount(c.item_count); return c; })
      .catch(function () {});
  }

  function addToCart(items, opts) {
    if (busy) return Promise.resolve();
    busy = true;
    opts = opts || {};
    var btn = opts.button;
    if (btn) setBtn(btn, 'loading');
    return cartFetch((R.cartAdd || '/cart/add') + '.js', { items: items })
      .then(function (res) {
        if (!res.ok) {
          var msg = (res.data && (res.data.description || res.data.message)) || 'Could not add that right now.';
          if (btn) setBtn(btn, 'error');
          toast(msg, 'error');
          return;
        }
        return afterMutation(res).then(function () {
          if (btn) setBtn(btn, 'success');
          if (opts.open !== false) openCart();
          if (opts.toast !== false) toast((opts.title ? opts.title + ' ' : '') + (S.strings.added || 'added'));
        });
      })
      .catch(function () {
        if (btn) setBtn(btn, 'error');
        toast('Network error — please try again.', 'error');
      })
      .then(function () { busy = false; });
  }

  function changeLine(key, qty, btn) {
    if (busy) return;
    busy = true;
    if (btn) btn.setAttribute('aria-busy', 'true');
    cartFetch((R.cartChange || '/cart/change') + '.js', { id: key, quantity: qty })
      .then(function (res) {
        if (!res.ok) { toast((res.data && res.data.message) || 'Could not update the bag.', 'error'); return; }
        return afterMutation(res);
      })
      .catch(function () { toast('Network error — please try again.', 'error'); })
      .then(function () { busy = false; });
  }

  function setBtn(btn, state) {
    btn.classList.remove('is-loading', 'is-ok', 'is-err');
    btn.removeAttribute('aria-busy');
    if (state === 'loading') { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); btn.disabled = true; return; }
    btn.disabled = false;
    if (state === 'success') { btn.classList.add('is-ok'); setTimeout(function () { btn.classList.remove('is-ok'); }, 1400); }
    if (state === 'error')   { btn.classList.add('is-err'); setTimeout(function () { btn.classList.remove('is-err'); }, 2000); }
  }

  /* add-to-cart forms + quick-add + qty steppers + remove — all delegated */
  doc.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-vc-add]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]');
    if (!id || !id.value) return;
    var qtyEl = form.querySelector('[name="quantity"]');
    var props = {};
    $$('[name^="properties["]', form).forEach(function (p) {
      var m = p.name.match(/properties\[(.+)\]/);
      if (m && p.value) props[m[1]] = p.value;
    });
    var line = { id: Number(id.value), quantity: Number(qtyEl && qtyEl.value ? qtyEl.value : 1) };
    var plan = form.querySelector('[name="selling_plan"]');
    if (plan && plan.value) line.selling_plan = Number(plan.value);
    if (Object.keys(props).length) line.properties = props;
    var submitBtn = form.querySelector('[type=submit]');
    var title = form.getAttribute('data-title') ||
                (submitBtn && submitBtn.getAttribute('data-title')) ||
                (form.querySelector('[data-title]') && form.querySelector('[data-title]').getAttribute('data-title'));
    addToCart([line], { button: submitBtn, title: title });
  });

  /* ---------------- kits: ask before adding ----------------
     A kit is two or three pieces at once, and the tile used to send a whole
     uniform to the bag on one press — picking the colour and the size itself.
     It got the colour right (the artwork is black) but the size was simply
     whichever one the product listed first, which is not a choice anyone made.

     So walk the pieces. Anything with one variant goes straight in; anything
     with a real choice opens the chooser, pre-set to the colour the tile is a
     picture of. Only once every piece has an answer does anything reach the
     bag — close the dialog halfway and nothing is added, which is what
     cancelling should mean. */
  function kitPieces(btn) {
    return (btn.getAttribute('data-kit-pieces') || '').split('~').filter(Boolean).map(function (raw) {
      var bits = raw.split('|');
      return { url: bits[0], id: Number(bits[1] || 0), needs: bits[2] === '1' };
    });
  }

  function kitAdd(btn) {
    var pieces = kitPieces(btn);
    if (!pieces.length) return;
    var prefer = btn.getAttribute('data-kit-prefer') || '';
    var nextLabel = btn.getAttribute('data-kit-next') || '';
    var finalLabel = btn.getAttribute('data-kit-cta') || (S.strings.addToCart || 'Add to bag');
    var chosen = [];
    var i = 0;

    function step() {
      /* everything that answers itself, in one go */
      while (i < pieces.length && !pieces[i].needs) {
        if (pieces[i].id) chosen.push(pieces[i].id);
        i++;
      }
      if (i >= pieces.length) { done(); return; }

      var more = false;
      for (var j = i + 1; j < pieces.length; j++) { if (pieces[j].needs) { more = true; break; } }

      pickOpen({
        url: pieces[i].url,
        button: btn,
        prefer: prefer,
        cta: more ? (nextLabel || finalLabel) : finalLabel,
        onPick: function (v) { chosen.push(v.id); i++; step(); }
      });
    }

    function done() {
      var ids = chosen.filter(Boolean);
      if (!ids.length) return;
      addToCart(ids.map(function (id) { return { id: id, quantity: 1 }; }),
                { button: btn, title: btn.getAttribute('data-title') });
    }

    step();
  }

  doc.addEventListener('click', function (e) {
    var q = e.target.closest('[data-quick]');
    if (q && q.tagName === 'BUTTON') {
      e.preventDefault(); e.stopPropagation();
      addToCart([{ id: Number(q.getAttribute('data-quick')), quantity: 1 }], { button: q, title: q.getAttribute('data-title') });
      return;
    }
    var kit = e.target.closest('[data-kit-pieces]');
    if (kit) {
      e.preventDefault();
      kitAdd(kit);
      return;
    }
    var step = e.target.closest('[data-line-step]');
    if (step) {
      e.preventDefault();
      changeLine(step.getAttribute('data-key'), Number(step.getAttribute('data-to')), step);
      return;
    }
    var rm = e.target.closest('[data-line-remove]');
    if (rm) {
      e.preventDefault();
      changeLine(rm.getAttribute('data-key'), 0, rm);
      return;
    }
  });

  doc.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    var v = Math.max(0, parseInt(input.value, 10) || 0);
    changeLine(input.getAttribute('data-key'), v, input);
  });

  /* ---------------- variant picker ----------------
     One dialog, opened from any "+" that belongs to a product with a choice to
     make. It asks the same questions the product page asks, in the same
     controls, and ends in the same place — the bag — so a shopper never loses
     the rail they were browsing just to pick a size.

     The card markup carries a product URL and nothing else; the option table is
     fetched from /products/<handle>.js the first time that product is opened
     and cached for the session. A rail of twenty products therefore ships no
     variant data at all until someone asks for it. */

  var pickCache = {};
  var pick = null;              /* the live selection state, null when closed */

  function pickRoot() { return $('#vcPick'); }

  function productJson(url) {
    var clean = String(url || '').split('?')[0].replace(/\/$/, '');
    if (pickCache[clean]) return Promise.resolve(pickCache[clean]);
    return fetch(clean + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (p) {
        /* /products/x.js returns options as objects today, but older shops
           return bare names with the values only on each variant. Normalise
           once here so nothing downstream has to care which shape arrived. */
        p.options = (p.options || []).map(function (o, i) {
          if (o && typeof o === 'object' && o.values) return o;
          var seen = [];
          p.variants.forEach(function (v) {
            var val = v.options[i];
            if (val != null && seen.indexOf(val) === -1) seen.push(val);
          });
          return { name: typeof o === 'string' ? o : 'Option ' + (i + 1), values: seen };
        });
        pickCache[clean] = p;
        return p;
      });
  }

  /* Is `value` at option `i` reachable, given everything else already chosen?
     Only the OTHER positions constrain it, so a shopper who picks an
     out-of-stock size can still switch colour and find it back in stock —
     locking both directions is what makes these pickers feel broken. */
  function pickReachable(p, sel, i, value) {
    return p.variants.some(function (v) {
      if (v.options[i] !== value) return false;
      for (var j = 0; j < sel.length; j++) {
        if (j !== i && sel[j] != null && v.options[j] !== sel[j]) return false;
      }
      return v.available;
    });
  }

  function pickMatch(p, sel) {
    if (sel.some(function (x) { return x == null; })) return null;
    return p.variants.filter(function (v) {
      return v.options.length === sel.length && v.options.every(function (o, i) { return o === sel[i]; });
    })[0] || null;
  }

  /* A swatch takes the option value as a CSS colour, the same rule the product
     page uses. "Off White" is not a colour keyword, so anything the browser
     refuses to parse falls back to a lettered chip rather than a silent blank. */
  var colourProbe = null;
  function pickColour(value) {
    if (!colourProbe) colourProbe = doc.createElement('span');
    var css = String(value || '').toLowerCase().replace(/\s+/g, '');
    colourProbe.style.backgroundColor = '';
    colourProbe.style.backgroundColor = css;
    return colourProbe.style.backgroundColor ? css : '';
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* "30W / 30L (Small)" reads as "Small"; "White / S" at the size position
     reads "S". Never "30L" — that is a leg length, not a choice anyone makes. */
  function pickShort(value) {
    var v = String(value || '').trim();
    var m = v.match(/\(([^)]+)\)\s*$/);
    if (m) return m[1].trim();
    if (v.indexOf(' / ') > -1) return v.split(' / ')[0].trim();
    return v;
  }

  function isColourOption(name) {
    return /colou?r/i.test(String(name || ''));
  }

  function pickPaint() {
    if (!pick) return;
    var root = pickRoot(), p = pick.product, sel = pick.sel;
    var box = $('[data-pick-opts]', root);

    box.innerHTML = p.options.map(function (opt, i) {
      var colour = isColourOption(opt.name);
      /* Only a colour names its choice back, the way the product page does — a
         size button already says "M" while it is lit, so echoing it beside the
         label just crowds the row with the same word twice. */
      var head = '<div class="opt-hd"><span>' + esc(opt.name) + '</span>' +
        (colour && sel[i] ? '<em>' + esc(sel[i]) + '</em>' : '') + '</div>';
      var body = opt.values.map(function (val) {
        var on = sel[i] === val;
        var off = !pickReachable(p, sel, i, val);
        var cls = (colour ? 'swb' : 'szb') + (on ? ' on' : '') + (off ? ' is-off' : '');
        var inner = colour
          ? (function () {
              var c = pickColour(val);
              return c
                ? '<span style="background:' + esc(c) + '"></span>'
                : '<span class="swb-x">' + esc(val.slice(0, 1).toUpperCase()) + '</span>';
            }())
          : esc(pickShort(val));
        return '<button class="' + cls + '" type="button" data-pick-val="' + esc(val) + '" data-pick-opt="' + i + '"' +
          ' aria-pressed="' + (on ? 'true' : 'false') + '" title="' + esc(val) + '"' +
          (colour ? ' aria-label="' + esc(val) + '"' : '') + '>' + inner + '</button>';
      }).join('');
      return '<div class="opt opt-row" data-pick-row="' + i + '">' + head +
        '<div class="' + (colour ? 'sw' : 'szs') + '">' + body + '</div></div>';
    }).join('');

    var v = pickMatch(p, sel);
    var priceEl = $('[data-pick-price]', root), wasEl = $('[data-pick-was]', root);
    var hint = $('[data-pick-hint]', root), addBtn = $('[data-pick-add]', root);
    var img = $('[data-pick-img]', root);

    if (v) {
      priceEl.textContent = fmt(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        wasEl.textContent = fmt(v.compare_at_price); wasEl.hidden = false;
      } else { wasEl.hidden = true; }
    } else {
      priceEl.textContent = (p.price_varies ? (S.strings.from || 'from') + ' ' : '') + fmt(p.price_min);
      wasEl.hidden = true;
    }

    /* The picture follows the choice, and does not wait for the choice to be
       finished. Colour is decided first and size second, so a shopper who picks
       black is looking at a white jacket for the whole of the next decision —
       and if the kit tile pre-picked black for them, they never chose it at all
       and the photograph flatly contradicts the swatch.

       Match on whatever has been decided so far, ignoring what has not, and
       prefer a variant that is actually in stock. Falls back to the product's
       own shot when nothing carries an image of its own. */
    var shot = '';
    var partial = p.variants.filter(function (x) {
      if (!x.featured_image || !x.featured_image.src) return false;
      return sel.every(function (chosenVal, i) { return chosenVal == null || x.options[i] === chosenVal; });
    });
    var inStock = partial.filter(function (x) { return x.available; });
    var use = (v && v.featured_image && v.featured_image.src) ? v : (inStock[0] || partial[0]);
    if (use && use.featured_image) shot = use.featured_image.src;
    if (!shot && typeof p.featured_image === 'string') shot = p.featured_image;
    if (shot && img.getAttribute('src') !== shot) img.src = shot;

    /* Name the first thing still missing, so the hint tells the shopper what to
       do rather than only that they cannot proceed yet. */
    var missing = -1;
    for (var i = 0; i < sel.length; i++) { if (sel[i] == null) { missing = i; break; } }
    var ok = !!(v && v.available);
    if (missing > -1) {
      hint.textContent = (isColourOption(p.options[missing].name)
        ? (S.strings.chooseColour || 'Choose a colour')
        : (S.strings.chooseSize || 'Choose a size')).replace('{{ option }}', p.options[missing].name);
      hint.hidden = false;
    } else if (!ok) {
      hint.textContent = S.strings.soldOut || 'Sold out';
      hint.hidden = false;
    } else {
      hint.hidden = true;
    }
    addBtn.disabled = !ok;
    pick.variant = ok ? v : null;
  }

  function pickOpen(cfg) {
    var root = pickRoot();
    if (!root) { if (cfg.url) window.location.href = cfg.url; return; }
    var trigger = cfg.button || null;
    if (trigger) setBtn(trigger, 'loading');

    productJson(cfg.url).then(function (p) {
      if (trigger) setBtn(trigger, '');
      /* A single-value option answers itself. Beyond that the caller may name a
         value it wants pre-picked — the kit tiles show black artwork, so the
         chooser they open should open on black rather than making the shopper
         re-state what the picture already said. Never pre-picks a value that is
         out of stock. */
      var prefer = String(cfg.prefer || '').trim().toLowerCase();
      var sel = p.options.map(function (o) {
        if (o.values.length === 1) return o.values[0];
        if (!prefer) return null;
        var hit = o.values.filter(function (v) { return String(v).toLowerCase() === prefer; })[0];
        return hit || null;
      });
      p.options.forEach(function (o, i) {
        if (sel[i] != null && o.values.length > 1 && !pickReachable(p, sel, i, sel[i])) sel[i] = null;
      });
      pick = { product: p, sel: sel, cfg: cfg, variant: null };

      $('[data-pick-title]', root).textContent = p.title;
      $('[data-pick-kind]', root).textContent = p.type || '';
      var img = $('[data-pick-img]', root);
      img.src = (p.featured_image || '');
      img.alt = p.title;
      var more = $('[data-pick-url]', root);
      more.href = p.url;
      $('[data-pick-cta]', root).textContent = cfg.cta || S.strings.addToCart || 'Add to bag';
      pickPaint();
      openLayer(root);
    }).catch(function () {
      if (trigger) setBtn(trigger, '');
      /* the dialog is a convenience, never the only way through — if its data
         will not load, send the shopper to the page that always works */
      if (cfg.url) window.location.href = cfg.url;
    });
  }

  function pickClose() { pick = null; closeLayer(pickRoot()); }

  doc.addEventListener('click', function (e) {
    if (e.target.closest('[data-pick-close]')) { e.preventDefault(); pickClose(); return; }

    var val = e.target.closest('[data-pick-val]');
    if (val && pick) {
      e.preventDefault();
      var i = Number(val.getAttribute('data-pick-opt'));
      var next = val.getAttribute('data-pick-val');
      /* A click always means what it says. Landing on a combination that is
         out of stock is allowed and simply says so — quietly un-picking the
         colour a shopper just chose, because the size they then chose does not
         come in it, is the kind of help nobody asked for. Nothing can get
         stuck: every value stays one click away. */
      pick.sel[i] = pick.sel[i] === next && pick.product.options[i].values.length > 1 ? null : next;
      pickPaint();
      return;
    }

    var add = e.target.closest('[data-pick-add]');
    if (add && pick && pick.variant) {
      e.preventDefault();
      var chosen = pick.variant, p = pick.product, cfg = pick.cfg;
      if (cfg.onPick) {
        cfg.onPick(chosen, p);
        pickClose();
        return;
      }
      /* Close on the way out, not on the way in: if the add fails the dialog is
         still there with the error on its button and the choice intact, rather
         than vanishing and leaving a toast to explain itself. */
      addToCart([{ id: chosen.id, quantity: 1 }], { button: add, title: p.title })
        .then(function () { if (!add.classList.contains('is-err')) pickClose(); });
      return;
    }

    /* the trigger itself: any + that belongs to a product with a choice */
    var pk = e.target.closest('[data-vc-pick]');
    if (pk) {
      e.preventDefault(); e.stopPropagation();
      pickOpen({ url: pk.getAttribute('data-vc-pick'), button: pk });
      return;
    }
  });

  /* ---------------- FAQ accordion (idempotent, delegated) ---------------- */
  doc.addEventListener('click', function (e) {
    var q = e.target.closest('.faq-q');
    if (!q) return;
    var item = q.closest('.faq-i');
    if (!item) return;
    var list = item.closest('.faq-l') || doc;
    var open = item.classList.contains('on');
    $$('.faq-i', list).forEach(function (o) {
      o.classList.remove('on');
      var b = o.querySelector('.faq-q');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
    if (!open) { item.classList.add('on'); q.setAttribute('aria-expanded', 'true'); }
  });

  /* ---------------- reveal on scroll ---------------- */
  var revealIO = null;
  function still() {
    return window.matchMedia('(max-width:760px)').matches
        || window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  }
  function initReveal(root) {
    var nodes = $$('.rvl:not(.in)', root || doc);
    if (!nodes.length) return;
    if (still()) { nodes.forEach(function (n) { n.classList.add('in'); }); return; }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (es) {
        var early = (performance.now() - revealIO.born) < 600;
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          if (early) en.target.classList.add('rvl-now');
          en.target.classList.add('in');
          revealIO.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      revealIO.born = performance.now();
    }
    /* Anything already inside the first viewport is painted at once and without
       a transition. Fading in what the visitor is looking at the moment the
       deferred bundle boots buys nothing and costs Speed Index: the viewport
       keeps changing long after it was first painted. Only what has to be
       scrolled to animates.

       Deliberately no getBoundingClientRect here: measuring forces a synchronous
       layout — and for nodes inside a `content-visibility:auto` section it
       forces the browser to render the whole skipped section just to answer.
       The observer already reports what is on screen; anything it reports
       within its first moments is treated as initially visible. */
    nodes.forEach(function (n) { revealIO.observe(n); });
    setTimeout(function () { nodes.forEach(function (n) { n.classList.add('in'); }); }, 2600);
  }

  /* ---------------- announcement rotator ---------------- */
  var abarTimer;
  function initAbar() {
    clearInterval(abarTimer);
    var t = $('.abar-track');
    if (!t || t.children.length < 2) return;
    var items = Array.prototype.slice.call(t.children);
    var i = 0;
    items.forEach(function (s, n) { s.style.display = n ? 'none' : 'flex'; });
    abarTimer = setInterval(function () {
      items[i].style.display = 'none';
      i = (i + 1) % items.length;
      items[i].style.display = 'flex';
    }, 4200);
  }

  /* ---------------- newsletter inline confirmation ---------------- */
  function initNl() {
    if (/customer_posted=true/.test(window.location.search)) {
      $$('.nl-ok').forEach(function (n) { n.classList.add('on'); });
    }
  }

  /* ---------------- horizontal rails: keep the snap padding honest -------- */
  function initRails(root) {
    $$('.snap', root || doc).forEach(function (r) {
      if (r.dataset.vcRail) return;
      r.dataset.vcRail = '1';
    });
  }

  /* ---------------- returning via the back button ----------------
     A button that starts a navigation is left in its loading state on purpose:
     the page is going away, so there is nothing to reset. Except the page does
     not always go away. Chrome and Safari keep it in the back/forward cache and
     hand back the exact DOM the shopper left — spinner still turning, button
     still disabled. Press Buy it now, land on checkout, press Back, and the
     button that got you there is now dead.

     `pageshow` with `persisted` is the only event that fires for that restore.
     Clear every state that only made sense while the page was leaving. */
  window.addEventListener('pageshow', function (e) {
    /* the in-flight guard: whatever it was waiting for is long gone */
    busy = false;

    $$('.is-loading, [aria-busy="true"]').forEach(function (b) {
      b.classList.remove('is-loading', 'is-ok', 'is-err');
      b.removeAttribute('aria-busy');
      /* never re-enable something the markup disabled for its own reasons —
         a sold-out control, a build with nothing in it */
      if (b.disabled && !b.hasAttribute('aria-disabled') && !b.classList.contains('is-off')) {
        b.disabled = false;
      }
    });

    if (!e.persisted) return;

    /* Shopify's own accelerated checkout button spins inside a shadow root we
       cannot reach. Its documented entry point re-renders the whole thing,
       which is the only way to get it back to a pressable state. */
    if (window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init) {
      try { window.Shopify.PaymentButton.init(); } catch (err) {}
    }
    /* the pre-2024 markup is in the light DOM, so it can just be cleaned */
    $$('.shopify-payment-button__button.loading').forEach(function (b) {
      b.classList.remove('loading');
      b.removeAttribute('disabled');
    });
  });

  /* ---------------- boot ---------------- */
  function boot(root) {
    initReveal(root);
    initRails(root);
    animateShip(root);
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', function () { boot(); initAbar(); initNl(); });
  } else { boot(); initAbar(); initNl(); }

  doc.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
    if (e.target.querySelector && e.target.querySelector('.abar-track')) initAbar();
  });

  /* ---------------- export ---------------- */
  window.VC = {
    $: $, $$: $$, fmt: fmt, toast: toast,
    addToCart: addToCart, changeLine: changeLine,
    openCart: openCart, closeCart: closeCart,
    openLayer: openLayer, closeLayer: closeLayer,
    setBtn: setBtn, initReveal: initReveal, paintCount: paintCount,
    pick: pickOpen, closePick: pickClose
  };
})();
